import { render, staticRenderFns } from "./AlunoRegister.vue?vue&type=template&id=bfd4aa38&"
import script from "./AlunoRegister.vue?vue&type=script&lang=ts&"
export * from "./AlunoRegister.vue?vue&type=script&lang=ts&"
import style0 from "./AlunoRegister.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports